import {useBooleanToggle} from '@travel-frontend/ui-components';
import {useCallback, useMemo} from 'react';

import {FilterOverlayContext} from '@/modules/common/context/FilterOverlay/context';

export const FilterOverlayProvider = ({children}: React.PropsWithChildren) => {
  const [isFilterOverlayOpen, toggleIsFilterOverlayOpen] = useBooleanToggle();

  const closeFilterOverlay = useCallback(
    () => toggleIsFilterOverlayOpen(false),
    [toggleIsFilterOverlayOpen]
  );

  const toggleFilterOverlay = useCallback(
    () => toggleIsFilterOverlayOpen(),
    [toggleIsFilterOverlayOpen]
  );

  const contextValue = useMemo(
    () => ({
      isFilterOverlayOpen,
      closeFilterOverlay,
      toggleFilterOverlay,
    }),
    [isFilterOverlayOpen, closeFilterOverlay, toggleFilterOverlay]
  );

  return (
    <FilterOverlayContext.Provider value={contextValue}>
      {children}
    </FilterOverlayContext.Provider>
  );
};
